<ng-container *ngIf="(view$ | async) as view; else loadingView">
<ng-container *ngIf="(tableMetaWithDataKey$ | async) as tableMeta; else loadingView">
  <ng-container *ngIf="(tableData$ | async) as tableData; else loadingView">
    <p-card>
      <p-table #dataTable preventSelectionSetterPropagation="false" [value]="tableData.items"
        [dataKey]="dataKey"
        [columns]="tableMeta.columns" [selection]="selectedItems$ | async"
        (selectionChange)="setSelectedItems($event)" 
        [selectionPageOnly]="true"
        [paginator]="true" responsiveLayout="stack"
        [loading]="(loadingState$ | async) ?? true" [lazy]="tableMeta.pagingSetup.lazy"
        [totalRecords]="tableData.totalRecords === undefined ? tableData.items.length : tableData.totalRecords"
        (onPage)="tableMeta.pagingSetup.pageHandler($event, tableData)"
        (onSort)="tableMeta.pagingSetup.sortHandler($event)" [filters]="tableData.filters" [rows]="tableData.rows"
        [rowsPerPageOptions]="(rowsPerPageOptions$ | async) ?? defaultRowsPageOptions"
        [first]="tableData.firstIndex" paginatorPosition="both" [showJumpToPageInput]="true">

        <ng-template pTemplate="caption" let-state>
          <div class="ui-paginator list-counter">
            <ntap-dynamic [compId]="tableToolbarCompId"></ntap-dynamic>
            <ntap-primeng-selection-info-bar [selectAllMode]="selectAllMode" [selectAllChecked]="selectAllCheckbox" [totalRecords]="tableData.totalRecords" [selectionLength]="dataTable.selection?.length"></ntap-primeng-selection-info-bar>
          </div>
        </ng-template>

        <ng-template pTemplate="paginatorleft" let-state>
          {{ (state.totalRecords > 0) ? (state.first + 1) : state.first }} -
          {{ (state.first + state.rows > state.totalRecords) ? state.totalRecords : state.first + state.rows }} od 
          {{ state.totalRecords }}
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr app-fast-data-entry-input-bar *ngIf="quickDataEntry" [inputs]="quickDataEntryInputs" [tableItemsLength]="tableData.items.length"></tr>
          <tr>
            <th *ngIf="tableMeta.selectionMode !== ''" class="table-col-checkbox"></th>
            <th *ngFor="let column of columns" [pSortableColumn]="column.name"
              [pSortableColumnDisabled]="!column.sortable && view.sortable_columns.length > 0">
                @if(isLockedColumn(column.name)) {
                  <i class="pi pi-key" pTooltip="{{  column.description  }}"
                    style="font-size: 1.5rem; color: var(--yellow-600)"></i>
                }
                @else if(!(dokumentacija && isIconColumn(column.name))){
                  {{ column.description }}
                }
                 <p-sortIcon *ngIf="column.sortable || (view.sortable_columns.length === 0 && column.dataType !== 'boolean')"
                    [field]="column.name" ariaLabel="true"></p-sortIcon>
            </th>
            <th ntapDebug>vstamp/Instance</th>
            <th *ngIf="tableMeta.hasActions" class="table-col-actions"></th>
          </tr>
          <tr>
            <th *ngIf="tableMeta.selectionMode !== ''" class="table-col-checkbox">
              <ng-container *ngIf="tableData.totalRecords > 0 && tableMeta.selectionMode === 'multiple'">
                <p-overlayPanel #op>
                  <p-radioButton name="option1" inputId="option1" value="PAGE" [ngModel]="selectAllMode" (ngModelChange)="selectedAllModeChanged($event)">
                  </p-radioButton>
                  <label for="option1" class="ml-2" >Odaberi sve na stranici</label>
                  <p-radioButton class="ml-2" name="option2" inputId="option2" value="ALL" [ngModel]="selectAllMode" (ngModelChange)="selectedAllModeChanged($event)">
                  </p-radioButton>
                  <label for="option2" class="ml-2">Odaberi sve rezultate</label>
                </p-overlayPanel>
                <p-tableHeaderCheckbox (click)="op.toggle($event);toggleHeaderCheckbox($event)"></p-tableHeaderCheckbox>
              </ng-container>              
            <th *ngFor="let column of columns">
                  @if(!(dokumentacija && isIconColumn(column.name))){
                   <ntap-prime-table-search [tableMeta]="tableMeta" [column]="column"></ntap-prime-table-search>
                  }
            </th>
            <th ntapDebug></th>
            <th *ngIf="tableMeta.hasActions" class="table-col-actions"
              [ngClass]="{'templateactions': quickDataEntry}"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" ngFor let-item let-rowIndex="rowIndex">
          <ng-container *ngIf="!inplaceEditing else inplace">
            <ng-container ntapListItemProvider #lid="ntapListItemProvider" [listIndex]="rowIndex" [item]="item"
              *ngIf="tableData.tableItems[tableMeta.pagingSetup.rowIndexFunction(tableData.firstIndex, rowIndex)] as tableItem">
              <tr>
                <td *ngIf="tableMeta.selectionMode !== ''" class="table-data-no-overflow table-col-checkbox">
                  <span class="ui-cell-content">
                    <p-tableCheckbox *ngIf="tableMeta.selectionMode === 'multiple'"  [value]="item"></p-tableCheckbox>
                    <p-tableRadioButton *ngIf="tableMeta.selectionMode === 'single'" [value]="item"></p-tableRadioButton>
                  </span>
                </td>

                <td *ngFor="let column of tableMeta.columns" (click)="toggleExpandedRow(tableData, item)"
                  [ngClass]="DISPLAY_TEXT_OVERFLOW ? (isRowExpanded(tableData, item) ? 'table-data-expanded' : 'table-data-overflow') : 'table-data-no-overflow'" [attr.data-value]="$any(tableItem)[column.name]">

                  @let isOpenItem = $any(column)["isOpenItemColumn"];

                  <ng-container *ngIf="isLockedColumn(column.name); else checkPublicCol">
                    <i *ngIf="item[column.name]" class="pi pi-lock" pTooltip="Zaključano"
                        style="font-size: 1.5rem; color: var(--red-500);"></i>
                    <i *ngIf="!item[column.name]" class="pi pi-lock-open" pTooltip="Otključano"
                        style="font-size: 1.5rem; color: var(--blue-500);"></i>
                  </ng-container>
                  <ng-template #checkPublicCol>
                    <ng-container *ngIf="isPublicColumn(column.name); else defaultColFormat">
                      <i *ngIf="item[column.name]" class="pi pi-eye" pTooltip="Objavljeno"
                          style="font-size: 1.5rem; color: var(--blue-500);"></i>
                      <i *ngIf="!item[column.name]" class="pi pi-eye-slash" pTooltip="Neobjavljeno"
                          style="font-size: 1.5rem; color: var(--red-500);"></i>
                    </ng-container>
                  </ng-template>
                  <ng-template #defaultColFormat>
                  <div *ngIf="column.controlType === 14 else plainTextFormat">
                    <span class="ui-cell-content"><a href="{{ item[column.name] }}">{{
                        item[column.name] | displayFormat:column }}</a></span>
                  </div>
                    <ng-template #plainTextFormat>
                      @if (dokumentacija) {
                        @if (isOpenItem) {
                        <a class="ui-cell-content" href="#" (click)="openItem($event, lid)"><b>
                          {{$any(tableItem)[column.name] | displayFormat:column }}</b></a>
                        }@else if(isIconColumn(column.name)){
                          <app-column-display [columnName]="column.name" [view]="view" [tableItem]="tableItem"></app-column-display>
                        }@else {
                           <span class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat:column }}</span>
                        }
                      }@else {
                        @if (isOpenItem) {
                          <a class="ui-cell-content" href="#" (click)="openItem($event, lid)"><b>
                            {{$any(tableItem)[column.name] | displayFormat:column }}</b></a>
                        }@else {
                        <span class="ui-cell-content">{{ $any(tableItem)[column.name] | displayFormat:column }}</span>
                        }
                      }
                    </ng-template>
                  </ng-template>
                  </td>

                <td ntapDebug>vstamp:{{ item[item['$mainType'] + '~vstamp'] }} {{ lid.toString() }}</td>
                <td *ngIf="tableMeta.hasActions" class="table-col-actions"
                  [ngClass]="{'templateactions': quickDataEntry}">
                  <span class="ui-cell-content">
                    <ntap-dynamic #rowActionBar compId="editActionbar"></ntap-dynamic>
                  </span>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-template #inplace>
            <ng-container *ngIf="(tableMetaWithDataKey$ | async) as tableMetaWithDataKey; else loadingView">
              <ng-container ntapListItemProvider #lid="ntapListItemProvider" [listIndex]="rowIndex" [item]="item"
                *ngIf="tableData.tableItems[tableMeta.pagingSetup.rowIndexFunction(tableData.firstIndex, rowIndex)] as tableItem">
                <tr [pEditableRow]="item" app-inplace-table-row [item]="item"
                  [tableMetaWithDataKey]="tableMetaWithDataKey" [readOnly]="readOnly" [tableData]="tableData" [tableItem]="tableItem"
                  [rowIndex]="rowIndex % tableData.rows" [readOnly$]="readOnly$(item)">
                </tr>
              </ng-container>
            </ng-container>
          </ng-template>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="tableMeta.totalColumns" class="table-data-no-overflow">
              Nema podataka.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </ng-container>
</ng-container>
</ng-container>
<ng-template #loadingView>
  <p-progressSpinner></p-progressSpinner>
</ng-template>